import React from 'react';
import { Section } from './ui/Section';
export function AuthorityTimeBlock() {
  return <Section background="charcoal" className="text-center" data-id="element-10">
      <div className="max-w-3xl mx-auto space-y-10" data-id="element-11">
        <div className="space-y-6 text-2xl md:text-4xl font-serif text-white leading-tight" data-id="element-12">
          <p data-id="element-13">It took months of testing to build this system.</p>
          <p className="text-luxury-gray" data-id="element-14">
            You can spend the next year guessing.
          </p>
          <p className="text-luxury-gold italic" data-id="element-15">
            Or install the structure today.
          </p>
        </div>
      </div>
    </Section>;
}